var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header',[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Monad Logo","src":require("@/assets/logo.png")}})]),_c('Nav'),_c('User')],1),_c('main',[_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Messages')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }